var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMajorCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.54692 4.6484L5.49634 0.683061C5.39853 0.565336 5.2238 0.549177 5.10608 0.646948C5.09298 0.657843 5.08086 0.669922 5.06996 0.683061L1.01938 4.6484C0.889863 4.76845 0.882192 4.97081 1.00224 5.10032C1.06178 5.16455 1.14502 5.20156 1.23259 5.2027H3.15128V10.3406C3.18767 10.5553 3.36134 10.7203 3.57766 10.7456H6.98869C7.15926 10.7456 7.20186 10.5325 7.20186 10.3406V5.2027H9.33375C9.51036 5.20038 9.65163 5.05536 9.6493 4.87875C9.64816 4.79118 9.61115 4.70794 9.54692 4.6484Z",
    fill: "#EFA12D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.98864 11.3848H3.57761C3.401 11.3848 3.25781 11.528 3.25781 11.7046C3.25781 11.8812 3.401 12.0244 3.57761 12.0244H6.98864C7.16525 12.0244 7.30843 11.8812 7.30843 11.7046C7.30843 11.528 7.16529 11.3848 6.98864 11.3848Z",
    fill: "#EFA12D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.98864 12.6641H3.57761C3.401 12.6641 3.25781 12.8072 3.25781 12.9839C3.25781 13.1605 3.401 13.3037 3.57761 13.3037H6.98864C7.16525 13.3037 7.30844 13.1605 7.30844 12.9839C7.30844 12.8072 7.16529 12.6641 6.98864 12.6641Z",
    fill: "#EFA12D"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorCategory);
export default __webpack_public_path__ + "static/media/majorCategory.46208f3272b623db02772f953e1d8d2b.svg";
export { ForwardRef as ReactComponent };